import { useAppSelector } from '../../../../app/store/hooks/Redux'
import { ExportDrop } from '../../../../shared/components/cards/export-drop/ExportDrop'
import React, { useEffect, useState } from 'react'
import { IDetailedInfoFilter } from '../../model/types/DetailedInfoFilter.interface'
import { selectDetailedInfoFilters } from '../../model/domainOverviewSlice'
import { useTranslation } from 'react-i18next'
import { useExportAdvertising } from '../../../../app/api'
import clsx from 'clsx'
import styles from './PagesPanel.module.scss'

export const PagesPanel = () => {
  const { t } = useTranslation()
  const detailedInfoFilter = useAppSelector<IDetailedInfoFilter>(selectDetailedInfoFilters)
  const {
    project,
    site,
    country,
    engine_id,
    dateRange: date,
    keyword,
    has_brand,
    page_url,
    show_hidden,
    reversed_filters,
  } = detailedInfoFilter
  const [queryParams, setQueryParams] = useState<any>()
  const [exportFile, { isFetching: isLoading }] = useExportAdvertising()

  useEffect(() => {
    if (!project) return

    setQueryParams({
      page: 1,
      'per-page': 10,
      projectId: +project,
      site,
      countryId: country ? +country : undefined,
      engineId: +engine_id,
      date,
      keywordId: keyword || undefined,
      hasBrand: has_brand,
      landingId: page_url || undefined,
      showHidden: show_hidden,
      reversedFilters: reversed_filters || undefined,
    })
  }, [detailedInfoFilter])

  return (
    <span className={clsx(styles.root)}>
      <ExportDrop
        columns={[
          { keys: ['title'], label: t('table.columns.page') },
          { keys: ['keywords_count'], label: t('table.columns.keyword(s)') },
          { keys: ['position'], label: t('table.columns.avgPosition') },
          { keys: ['previous_position'], label: t('table.columns.previousPosition') },
          { keys: ['top_keyword'], label: t('table.columns.topKeyword') },
          { keys: ['landing_page'], label: t('table.columns.landingPage') },
          { keys: ['last_found'], label: t('table.columns.lastFound') },
        ]}
        loading={isLoading}
        onExport={(exportParams) => exportFile({ ...queryParams, ...exportParams })}
      />
    </span>
  )
}
